"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Master = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("../Base");
const Master = ({ colour = "#282828", size = 32, title = "Master Job" }) => (react_1.default.createElement(Base_1.Base, { size: size, title: title, smooth: true, viewBox: "0 0 32 32" },
    react_1.default.createElement("path", { fill: colour, d: "M16,7.4l2.8,5.6L25,14l-4.5,4.4l1.1,6.2L16,21.6l-5.6,2.9l1.1-6.2L7,14l6.2-0.9L16,7.4z" })));
exports.Master = Master;
//# sourceMappingURL=Master.js.map